<template>
 <div>
 <v-dialog v-model="feedbackDialog" width="400" persistent>
	<v-card class="mx-auto">
		<v-card-title class="headline" primary-title>Rate Lingo AV</v-card-title>
		<v-card-text>If you enjoy using our service, please take a few seconds to rate your experience. It really helps us improve!
			<div class="text-xs-center mt-2">
				<v-rating v-model="rating" color="rgb(77, 144, 212)" background-color="grey darken-1" :empty-icon="emptyIcon"
:full-icon="fullIcon" hover class="mb-2"></v-rating>
			</div>
			<v-textarea outline hint="Leave a comment, we love them" v-model="feedbackComment" counter :maxlength="maxChars"></v-textarea>
		</v-card-text>
		<v-divider></v-divider>
		<v-card-actions class="justify-space-between">
			<v-btn flat @click="cancelFeedback()">Not Now</v-btn>
			<v-btn color="primary" flat @click="acceptFeedback()" :disabled="!rating">Rate Us</v-btn>
		</v-card-actions>
	</v-card>
</v-dialog>

<v-snackbar v-model="snackbar" :timeout="timeout">Your feedback was gladly accepted</v-snackbar>
 </div>
</template>

<style>
	
</style>

<script>

import FeedbackService from '../service/feedbackService';

  export default {
   name: 'lingo_feedback',
    data () {
      return {
		feedbackComment: '',
		feedbackDialog: false,
		rating: 0,
		emptyIcon: 'filter_vintage',
		fullIcon: 'filter_vintage',
		maxChars: 1000,
		snackbar: false,
      	timeout: 4000
      }
    },
	mounted () {
		this.$store.subscribe((mutation, state) => {
			if (state.feedbackDialog) {
				this.feedbackDialog = true;
			}
		})
	},
	methods : {
		cancelFeedback () {
			this.feedbackComment = '';
			this.feedbackDialog = false;
			this.rating = 0;
			this.$store.commit('setFeedbackDialog', false);
		},
		acceptFeedback () {
			var that = this;
			FeedbackService.postFeedback(this.feedbackComment, this.rating, function(jsonResult) {
				that.cancelFeedback();
				setTimeout(() => that.snackbar = true, 3000);
		});
		}	
	}
}
</script>
